import { render, staticRenderFns } from "./RequestReturQuestionMark.vue?vue&type=template&id=8d097c5a"
import script from "./RequestReturQuestionMark.vue?vue&type=script&lang=js"
export * from "./RequestReturQuestionMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports